<template>
  <div
    v-loading="loadingText"
    :element-loading-text="loadingText"
    class="p-20 mobile-l:p-25 tablet:p-35"
  >
    <EventEditForm
      v-if="eventsLoadingStatus !== 'init'"
      :existing-event-data="currentEvent"
      :is-loading.sync="eventIsBeingUpdated"
      class="w-full tablet:max-w-500"
      @submit-successful="onSubmitSuccessful($event)"
      @submit-failed="onSubmitFailed"
    />
  </div>
</template>

<script>
import LogRocket from 'logrocket';
import { mapState, mapActions } from 'vuex';
import { FSGetUserEvent } from '@/helpers/firestoreRefs';
import { showErrorNotification, showSuccessNotification } from '@/utils/notification';
import EventEditForm from '@/components/event/EventEditForm';

export default {
  props: {
    eventID: {
      type: String,
      default: '',
    },
  },
  components: {
    EventEditForm,
  },
  data: () => ({
    eventIsBeingUpdated: false,
  }),
  created() {
    this.getUserEvent(this.eventID);
  },
  computed: {
    ...mapState('user/events', {
      eventsLoadingStatus: 'loadingStatus',
      allEvents: 'all',
    }),
    loadingText() {
      if (this.eventsLoadingStatus === 'init') return 'Getting your event..';
      if (this.eventIsBeingUpdated) return 'Updating your event..';

      return '';
    },
    currentEvent() {
      if (this.eventLoadingStatus === 'init') return null;
      return this.allEvents[this.eventID];
    },
  },
  methods: {
    ...mapActions('navigation', {
      updateCurrentNavigationTitleSuffix: 'updateCurrentNavigationTitleSuffix',
    }),
    ...mapActions('user/events', {
      onUserEventSnapshot: 'onEventSnapshot',
    }),
    getUserEvent(eventId) {
      return FSGetUserEvent(eventId)
        .get()
        .then((snapshot) => {
          this.onUserEventSnapshot(snapshot);
        })
        .catch((error) => {
          LogRocket.captureException(error);
          console.error(error);
        });
    },
    onSubmitSuccessful(eventId) {
      this.$router.push({ name: 'EventDetails', params: { eventID: eventId } });
      showSuccessNotification('Updated the Event successfully.');
    },
    onSubmitFailed(error) {
      showErrorNotification(error.message);
    },
  },
  beforeDestroy() {
    this.updateCurrentNavigationTitleSuffix('');
  },
};
</script>

<style scoped>
</style>
